import React, { useState } from 'react';
import cx from 'classnames';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { DealAgentHighlight } from 'src/types/dealAgent';
import styles from './styles.module.scss';
import { get, size } from 'lodash';

interface HighlightsProps {
  highlights?: DealAgentHighlight[] | null;
}

const Highlights: React.FC<HighlightsProps> = ({
  highlights,
}) => {

  if (!highlights || size(highlights) === 0) { 
    return <></>;
  }

  return (
    <div className={styles.highlightsContainer}>
        <div className={styles.header} >
          <p className={styles.title}>Highlights</p>
        </div>
      
        <div className={styles.pillsContainer}>
          {highlights.map((highlight, index) => {
            const renderLabel = <p className={cx(styles.label)} >
               {get(highlight, 'name', '-')}
            </p>;

            return get(highlight, 'description') || get(highlight, 'source') ? (
              <OverlayTrigger
                key={index}
                placement="top-start"
                trigger={['hover']}
                container={document.body}
                popperConfig={{
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 8],
                      },
                    },
                  ],
                }}
                overlay={
                  <Popover className={styles.popover} placement="top">
                    <Popover.Body>
                      <p className={styles.popoverTitle}>{get(highlight, 'name', '-')}</p>
                      {get(highlight, 'description') && <p className={styles.popoverContent}>{get(highlight, 'description')}</p>}
                      {get(highlight, 'source') && <p className={styles.popoverSource}>Source: {get(highlight, 'source',)}</p>}
                    </Popover.Body>
                  </Popover>
                }
              >
              {renderLabel}
              </OverlayTrigger>
            ): renderLabel })}
        </div>
 
    </div>
  );
};

export default Highlights;
